var cache = new Map();
/**
 * 注册计算包围盒的算法
 * @param type 方法名
 * @param method 方法
 */
export function register(type, method) {
    cache.set(type, method);
}
/**
 * 获取计算包围盒的算法
 * @param type 方法名
 */
export function getMethod(type) {
    return cache.get(type);
}
//# sourceMappingURL=register.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/g-base/esm/bbox/register.js
// module id = null
// module chunks = 